"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimisticMinting = void 0;
class OptimisticMinting {
    constructor(tbtcContracts) {
        this.tbtcContracts = tbtcContracts;
    }
    /**
     * Requests optimistic minting for a deposit on chain.
     * @param depositTxHash The revealed deposit transaction's hash.
     * @param depositOutputIndex Index of the deposit transaction output that
     *        funds the revealed deposit.
     * @returns Transaction hash of the optimistic mint request transaction.
     */
    async requestMint(depositTxHash, depositOutputIndex) {
        return this.tbtcContracts.tbtcVault.requestOptimisticMint(depositTxHash, depositOutputIndex);
    }
    /**
     * Cancels optimistic minting for a deposit on chain.
     * @param depositTxHash The revealed deposit transaction's hash.
     * @param depositOutputIndex Index of the deposit transaction output that
     *        funds the revealed deposit.
     * @returns Transaction hash of the optimistic mint cancel transaction.
     */
    async cancelMint(depositTxHash, depositOutputIndex) {
        return this.tbtcContracts.tbtcVault.cancelOptimisticMint(depositTxHash, depositOutputIndex);
    }
    /**
     * Finalizes optimistic minting for a deposit on chain.
     * @param depositTxHash The revealed deposit transaction's hash.
     * @param depositOutputIndex Index of the deposit transaction output that
     *        funds the revealed deposit.
     * @returns Transaction hash of the optimistic mint finalize transaction.
     */
    async finalizeMint(depositTxHash, depositOutputIndex) {
        return this.tbtcContracts.tbtcVault.finalizeOptimisticMint(depositTxHash, depositOutputIndex);
    }
    /**
     * Gets optimistic minting request for a deposit from chain.
     * @param depositTxHash The revealed deposit transaction's hash.
     * @param depositOutputIndex Index of the deposit transaction output that
     *        funds the revealed deposit.
     * @returns Optimistic minting request.
     */
    async getMintingRequest(depositTxHash, depositOutputIndex) {
        return this.tbtcContracts.tbtcVault.optimisticMintingRequests(depositTxHash, depositOutputIndex);
    }
}
exports.OptimisticMinting = OptimisticMinting;
//# sourceMappingURL=optimistic-minting.js.map